import { Inbox } from 'lucide-react';

interface ChartEmptyProps {
  /** One sentence saying what is missing. */
  message: string;
  /** Match the chart's height so the card does not jump. */
  height: number;
  testId: string;
}

/**
 * Empty state for a chart with nothing to draw: an icon in a muted circle and
 * one sentence, in place of bare axes that read as broken.
 */
export function ChartEmpty({ message, height, testId }: ChartEmptyProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 text-center" style={{ height }} data-testid={testId}>
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-muted">
        <Inbox className="h-5 w-5 text-muted-foreground" />
      </span>
      <p className="max-w-xs text-sm text-muted-foreground">{message}</p>
    </div>
  );
}
